import React, { useEffect, useRef } from "react";
import "./SectionTitle.css";

function SectionTitle({ text }) {
  const titleRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.3 }
    );

    if (titleRef.current) observer.observe(titleRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div className="section-title-wrapper">
      <h2 ref={titleRef} className="section-title">
        {text}
      </h2>
    </div>
  );
}

export default SectionTitle;
